<template>
  <div class="" style="position: relative;">

    <v-toolbar>
      <v-toolbar-title>
        <v-btn @click="backPage()" class="back_button">
          <v-icon color="blue darken-2"> mdi-arrow-left </v-icon
          >マップ一覧に戻る
        </v-btn>

        マップデータ確認</v-toolbar-title
      >
    </v-toolbar>



    <!-- {{ map_data }} -->

    <!-- {{ map_data.category}} -->

    <v-card class="pa-4" max-width="100%" style="margin: 10px 10px;">
      <!-- <v-btn @click="backPage()" class="back_button mb-2" outlined>
        <v-icon color="blue darken-2"> mdi-arrow-left </v-icon>マップ一覧に戻る
      </v-btn> -->

      <!-- CSV読み込みボタン -->
      <v-row>
        <v-col cols="5">
          <label>
            <input type="file" @change="loadCsvFile($event)" /><span
              style="color:red;font-size:12px;padding-left:10px;"
              >（CSVファイル読み込み）</span
            >
          </label></v-col
        >
        <v-col cols="7">
          <v-btn
            @click="save()"
            color="primary"
            class="back_button mb-2"
            v-show="update_flg"
            style="color: #fff !important"
          >
            データ更新
          </v-btn>

          <div v-html="update_message"></div>
        </v-col>
      </v-row>

      <h2 class="my-2">【{{ parent_id }}_{{ id }}】{{ map_name }}</h2>

      <div class="flex_table mb-4">
        <table
          v-for="(cate, category_id) in map_data.category"
          v-bind:key="category_id"
          class="ma-0 map_setting_table"
        >
          <tr>
            <th>{{ cate.name }}{{ category_id }}</th>
          </tr>

          <tr>
            <td class="pa-0">
              <table>
                <tr>
                  <td
                    v-for="icon_id in cate.icons"
                    v-bind:key="icon_id"
                    class="map_custom ma-0 pa-0"
                  >
                    <div class="text-center ma-0 pa-1">
                      <img
                        :src="
                          'https://appmedia.jp' + map_data.icons[icon_id].img
                        "
                        width="30"
                        height="30"
                      />{{ icon_id }}
                      <div style="font-size: 12px;">
                        {{ map_data.icons[icon_id].name }}
                      </div>
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <!-- -->
        </table>
      </div>

      <div class="d-flex" style="align-items: center;">
        <p>
        map_id, map_sub_id、idとimg_noは、必須。<span class="orange">__</span>のカラムだけCSVから変更可能。
      </p>
      <v-spacer></v-spacer>
      <div style="text-align: right">
        <v-btn @click="download" color="primary" outlined>CSVダウンロード</v-btn>
      </div>
      </div>


      <table class="map_position_table">
        <thead>
          <tr>
            <th width="70" style="color:red;">map_id</th>
            <th width="70" style="color:red;">map_sub_id</th>
            <th width="90" style="color:red;">id</th>
            <th width="70">category</th>
            <th width="70" style="color:red;">img_no</th>
            <th width="110">アイコン</th>

            <th width="70">lat</th>

            <th width="70">lng</th>
            <th width="120" class="orange">label</th>
            <th width="120" class="orange">search_group</th>
            <th class="orange">content</th>
          </tr>
        </thead>
        <tbody v-for="child in map_data.markers" v-bind:key="child.id">
          <tr
            v-for="item in child"
            v-bind:key="item.id"
            v-show="map_data.icons[item.img_no]"
          >
            <td>{{ parent_id }}</td>
            <td>{{ item.sub_map_id || id }}</td>
            <td>{{ item.id }}</td>

            <td>{{ iconCategory(item.img_no) }}</td>
            <td>{{ item.img_no }}</td>

            <td>{{ iconName(item.img_no) }}</td>
            <td>{{ item.lat }}</td>
            <td>{{ item.lng }}</td>

            <td>{{ item.label || "" }}</td>
            <td>{{ item.search_group || "" }}</td>
            <td>{{ item.content || "" }}</td>
          </tr>
        </tbody>
      </table>
    </v-card>
  </div>


</template>

<script>
import axios from "axios";
import Papa from "papaparse";

import getMapList from "@/plugins/mapping_list";


export default {
  name: "MapGenerateList",
  components: {},
  data() {
    return {
      master_data: [],
      map_data: [],
      parent_id: "",
      id: "",
      map_name: "",
      csvData: [],
      message: "",
      update_message: "",
      items: [],

      //サブフラグ
      sub_flg: false,
      //更新フラグ
      update_flg: false,

      update_sub_ids: [], //更新するサブidを格納

      // icon_data = {},
    };
  },
  mounted() {
    // var self = this;


    //マップデータの取得



    // this.greeting = await greet(self.parent_id , self.id)

    this.test()

    // var access_url = "";

    // if (typeof self.id !== "undefined" && self.id != -1) {
    //   access_url = process.env.VUE_APP_MAP_SUB_DETAIL;
    //   axios
    //     .get(access_url, {
    //       params: {
    //         id: self.id,
    //         parent_id: self.parent_id,
    //       },
    //     })
    //     .then(function(response) {
    //       console.log("sub", response.data);
    //       self.master_data = response.data.main;
    //       self.map_data = JSON.parse(response.data.sub.content);

    //       //メインデータに置き換え（基本情報)
    //       var main = JSON.parse(response.data.main.content);
    //       self.map_data.category = main.category;
    //       self.map_data.icons = main.icons;

    //       self.map_name =
    //         response.data.main.name + "_" + response.data.sub.name;

    //       console.log("メインデータ", self.map_data);
    //     })
    //     .finally(function() {});
    // } else {
    //   access_url = process.env.VUE_APP_MAP_DETAIL;
    //   axios
    //     .get(access_url, {
    //       params: {
    //         id: self.parent_id,
    //       },
    //     })
    //     .then(function(response) {
    //       self.master_data = response.data;

    //       self.map_data = JSON.parse(response.data.content);
    //       self.map_name = response.data.name;

    //       //サブマップがある場合はそちらを優先
    //       let sub_markes = response.data.sub_markes;
    //       if (sub_markes) {
    //         console.log("sub_markes", sub_markes);
    //         self.sub_flg = true;

    //         let all_data = {};

    //         for (const sub_map_id in sub_markes) {
    //           if (Object.hasOwnProperty.call(sub_markes, sub_map_id)) {
    //             const element = sub_markes[sub_map_id];
    //             // console.log("sub_markes", element.markers);

    //             for (let icon_id in element.markers) {
    //               if (!all_data[icon_id]) {
    //                 all_data[icon_id] = [];
    //               }

    //               const value = element.markers[icon_id];
    //               for (let index in value) {
    //                 const child = value[index];
    //                 child.sub_map_id = sub_map_id;
    //                 all_data[icon_id].push(child);
    //               }
    //             }
    //           }
    //         }
    //         console.log(all_data);
    //         self.map_data.markers = all_data;
    //       }

    //       console.log("map_data", self.map_data);
    //     })
    //     .finally(function() {});
    // }
  },

  computed: {},

  watch: {},

  methods: {

    async test(){
      var self = this
      self.parent_id = this.$route.params.parent_id;
      self.id = this.$route.params.id;
      // this.greeting = await greet(self.parent_id , self.id)

      
      const result = await getMapList(self.parent_id , self.id)
      self.map_data = result.map_data
      self.map_name = result.map_name
      self.master_data = result.master_data
      self.sub_flg = result.sub_flg
      // alert(self.sub_flg)
    },

    backPage() {
      this.$router.push({
        name: "mapGenerate",
      });
    },

    iconName(no) {
      if (this.map_data.icons[no]) {
        return this.map_data.icons[no].name;
      }
      return no;
    },
    iconCategory(no) {
      if (this.map_data.icons[no]) {
        var category_id = this.map_data.icons[no].category;

        return this.map_data.category[category_id].id;
      }
      return no;
    },

    //CSVファイルのの読み込み
    loadCsvFile(e) {
      this.csvData = [];
      this.message = "";
      let file = e.target.files[0];
      this.update_flg = false;

      if (file.name && file.name.indexOf(".csv") <= -1) {
        this.message = "CSVファイルを選択してください";
        return;
      }

      let reader = new FileReader();
      reader.readAsText(file);
      reader.onload = () => {
        let csvData = reader.result;
        const parsed = Papa.parse(csvData, { header: true });
        this.rows = parsed.data;
        this.changeData(parsed.data);
      };
      console.log(this.map_data);
    },

    //読み込んだCSVデータの反映
    changeData(after) {
      this.update_message = "";
      this.update_flg = false;
      this.update_sub_ids = [];
      for (let key in after) {
        const data = after[key];
        const target_img_no = data.img_no;
        const target_id = data.id;

        if (this.map_data.markers[target_img_no]) {
          this.map_data.markers[target_img_no].forEach((element) => {
            if (element.id == target_id) {
              if (data.content || data.content == "") {
                element.content = data.content;
              }
              if (data.search_group || data.search_group == "") {
                element.search_group = data.search_group;
              }
              if (data.label || data.label == "") {
                element.label = data.label;
              }

              if (
                this.update_sub_ids.indexOf(element.sub_map_id) === -1 &&
                this.sub_flg
              ) {
                this.update_sub_ids.push(element.sub_map_id);
              }
              this.update_flg = true;
            }
          });
        }
      }

      if(!this.update_flg){
        alert("不正なCSVデータです。map_idが正しいか確認してください。")
      }

      console.log("map_data_markers", this.map_data.markers);
    },

    fetchData(url, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(url, {
            data: data,
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    //CSVダウンロード
    download() {
      let output = []
      // let result = Object.assign({}, this.map_data.markers);
      let result = JSON.parse(JSON.stringify(this.map_data.markers));

      
      for (let img_no in result) {
          const data = result[img_no];
          data.forEach((element) => {
            console.log(element)

            let item = {}
            item.map_id = this.parent_id
            item.sub_map_id = element.sub_map_id || ""
            item.id = element.id
            item.category = this.iconCategory(element.img_no)
            item.img_no = element.img_no
            item.アイコン = this.iconName(element.img_no)
            item.lat = element.lat
            item.lng = element.lng
            item.label = element.label || ""

            // カンマが含まれている場合、ダブルクオーテーションで囲む
            if (typeof element.search_group === 'string' && (element.search_group.includes(',') || element.search_group.includes('"'))) {
              element.search_group = `"${element.search_group.replace(/"/g, '""')}"`; // ダブルクオーテーション内のダブルクオーテーションもエスケープ
            }

            item.search_group = element.search_group || ""
            item.content = element.content || ""

            if(this.map_data.icons[element.img_no]){
              output.push(item)
            }
          });
      }


      // let outputData = this.map_data.markers.map((item) => {
      //   // プロパティの順序を明示的に指定して新しいオブジェクトを作成
      //   const newItem = {
      //     date: item.date, // まずnameを追加
      //     pv: item.pv, // 次にidを追加
      //     session: item.session, // 次にidを追加
      //     user: item.user, // 次にidを追加
      //   };

      //   return newItem;
      // });

      console.log("outputData",output);

      // // バイナリ形式で作成
      const blob = new Blob([this.convertObjectToCSV(output)], {
        type: "text/csv",
      });
      const url = (window.URL || window.webkitURL).createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;

      let file_name = "";
      if(!this.id){
        file_name = this.parent_id+"_all_"+this.map_name + ".csv";
      }else{
        file_name = this.parent_id+"_"+this.id+"_"+this.map_name + ".csv";
      }

      a.download = file_name;
      document.body.appendChild(a);
      a.click();
    },

    /** Object の配列を受け取り CSV形式の文字列に変換する Func */
    convertObjectToCSV(objArray) {
        const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
        let str = '';

        // CSVヘッダを追加
        for (let i = 0; i < array.length; i++) {
            let line = '';
            for (let key in array[i]) {
                if (line !== '') line += ',';
                line += key;
            }
            str += line + '\r\n';
            break;
        }

        // データ行を追加
        for (let i = 0; i < array.length; i++) {
            let line = '';
            for (let key in array[i]) {
                if (line !== '') line += ',';
                line += array[i][key];
            }
            str += line + '\r\n';
        }
        return str;
    },

    save() {
      if (!this.update_flg) {
        console.log("何も変更されていない");
        return;
      }

      this.update_message = "";

      console.log("this.update_sub_ids", this.update_sub_ids);
      let updateItem = {};
      // saveData.content = {};
      // saveData.content.markers = {};

      this.update_sub_ids.forEach((target_sub_id) => {
        console.log("map_data_markers", target_sub_id);
        updateItem[target_sub_id] = {};
        for (let img_no in this.map_data.markers) {
          const data = this.map_data.markers[img_no];
          data.forEach((element) => {
            if (element.sub_map_id == target_sub_id) {
              if (!updateItem[target_sub_id][img_no]) {
                updateItem[target_sub_id][img_no] = [];
              }
              updateItem[target_sub_id][img_no].push(element);
            }
          });
        }
      });

      //サブマップデータの更新
      var self = this;

      if (this.sub_flg) {
        console.log(" ****** save_sub ******");
        this.update_sub_ids.forEach((sub_id) => {
          let saveData = Object.assign({}, this.master_data);
          const parent_id = saveData.id;
          saveData.parent_id = parent_id;
          saveData.id = sub_id;
          saveData.updata_content_only = true;
          saveData.content = {};
          saveData.content.markers = updateItem[sub_id];

          axios
            .post(process.env.VUE_APP_MAP_SUB_UPDATE, {
              data: saveData,
            })
            .then(function(response) {
              console.log("結果",response);
              //新規追加
              if (
                response.data["status"] == 0 ||
                response.data["status"] == 1 ||
                response.data["status"] == 2
              ) {
                if (response.data["status"] === false) {
                  alert("データの保存に失敗しました。");
                } else {
                  self.update_message +=
                    "サブマップID" + sub_id + "のデータを更新しました。<br />";

                  // alert("データを保存しました。");
                }
              } else {
                if (response.data == "ERROR_SAME_NAME") {
                  alert("同じ保存名が存在しています。");
                } else {
                  alert("更新失敗しました！");
                }
              }
            })
            .finally(function() {
              // self.overlay = false;
            });
        });
      } else {
        let saveData = Object.assign({}, this.master_data);
        saveData.content = JSON.parse(saveData.content);
        saveData.content.markers = this.map_data.markers;


        console.log(" ****** save_main ******",saveData);


        axios
          .post(process.env.VUE_APP_MAP_UPDATE, {
            data: saveData,
          })
          .then(function(response) {
            console.log(response);
            //新規追加
            if (
              response.data["status"] == 0 ||
              response.data["status"] == 1 ||
              response.data["status"] == 2
            ) {
              if (response.data["status"] === false) {
                alert("データの保存に失敗しました。");
              } else {
                self.update_message += "データを更新しました。<br />";
                // alert("データを保存しました。");
              }
            } else {
              if (response.data == "ERROR_SAME_NAME") {
                alert("同じ保存名が存在しています。");
              } else {
                alert("更新失敗しました！");
              }
            }
          })
          .finally(function() {
            // self.overlay = false;
          });
      }
      this.update_flg = false;

      // this.update_sub_ids.forEach((sub_id) => {
      //   let saveData = Object.assign({}, this.master_data);
      //   const parent_id =  saveData.id;
      //   saveData.parent_id = parent_id;
      //   saveData.id = sub_id;
      //   saveData.content = {};
      //   saveData.content.markers = updateItem[sub_id];
      //   // console.log("saveData", saveData.content);

      //   this.fetchData(process.env.VUE_APP_MAP_SUB_UPDATE,saveData).then(response => {
      //     // データの処理
      //                 console.log("sub_id",sub_id,response);
      //       //新規追加
      //       if (
      //         response.data["status"] == 0 ||
      //         response.data["status"] == 1 ||
      //         response.data["status"] == 2
      //       ) {
      //         if (response.data["status"] === false) {
      //           alert("データの保存に失敗しました。");
      //         } else {
      //           alert("データを保存しました。");
      //         }
      //       } else {
      //         if (response.data == "ERROR_SAME_NAME") {
      //           alert("同じ保存名が存在しています。");
      //         } else {
      //           alert("更新失敗しました！");
      //         }
      //       }
      //   })
      //   .catch(error => {
      //     // エラーの処理
      //     console.log(error);
      //   });

      //  axios
      //   .post(process.env.VUE_APP_MAP_SUB_UPDATE, {
      //     data: saveData,
      //   })
      //   .then(function(response) {
      //     console.log(response);
      //     //新規追加
      //     if (
      //       response.data["status"] == 0 ||
      //       response.data["status"] == 1 ||
      //       response.data["status"] == 2
      //     ) {
      //       if (response.data["status"] === false) {
      //         alert("データの保存に失敗しました。");
      //       } else {
      //         alert("データを保存しました。");
      //       }
      //     } else {
      //       if (response.data == "ERROR_SAME_NAME") {
      //         alert("同じ保存名が存在しています。");
      //       } else {
      //         alert("更新失敗しました！");
      //       }
      //     }
      //   })
      //   .finally(function() {
      //     // self.overlay = false;
      //   });
      // });
    },

    // backPage() {
    //   this.$router.push({
    //     name: "mapGenerate",
    //   });
    // },
  },
};
</script>
<style scoped>
.map_position_table {
  width: 100%;
  font-size: 12px;
}
.map_position_table th {
  background: #edd;
  padding: 4px;
}

.map_position_table td {
  text-align: center;
  border: 1px solid #ddd;
  background: #fff;
  padding: 4px;
}
.icon_list {
  list-style: none;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
}
.icon_list li {
  min-width: 80px;
  text-align: center;
  border: 1px solid #ddd;
  margin: 1px;
  font-size: 12px;
}
.flex_table {
  display: flex;
  flex-wrap: wrap;
}
.flex_table table {
  background: #fff;
}
.flex_table td {
  text-align: center;
  border: 1px solid #ddd;
  background: #fff;
}
.flex_table th {
  background: rgb(135, 199, 239);
  padding: 4px;
}
.flex_table .map_setting_table {
  width: auto;
}
</style>
